export default __webpack_public_path__ + "static/moon-panorama-ddd61ee939a941f438587ec0ff444c53.jpg";